import Select from './Select'

export default Select



// WEBPACK FOOTER //
// ./src/components/select/index.js